import React from 'react'
import { translate } from 'react-i18next'

const Address = ({ ind, t, lang }) => (
  <div>
    <p className="body-light">{t(`contacts.address.${ind}.country`)}</p>
    <p className="body-light">{t(`contacts.address.${ind}.street`)}</p>
    <a href={`tel:${lang === 'ru' && ind === 2 || lang === 'de' && ind === 2 ? '+375173363757' : t(`contacts.address.${ind}.tel`)}`} className="body-light">
      {lang === 'ru' && ind === 2 || lang === 'de' && ind === 2  ? '+375 17 336 37 57' : t(`contacts.address.${ind}.tel`)}
    </a>
  </div>
)

export default translate('translations')(Address)
